import React from 'react';
import '../assets/styles/Contact.scss';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FileIcon from '@mui/icons-material/FileOpen';
import CV from '../assets/documents/cv_homepage.pdf';

function Contact() {
  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Get in touch</h1>
          <p className="contact-lead">
            I enjoy turning data into insights and building models that deliver real impact.
            I thrive in open, dynamic teams — let’s connect and explore opportunities in
            quantitative research and systematic investing.
          </p>

          <div className="contact-actions">
            <a href="mailto:stecherm01@gmail.com" className="btn-accent">
              <EmailIcon fontSize="small" /> Email me
            </a>
            <a
              href="https://www.linkedin.com/in/martin-stecher-3408a3195/"
              target="_blank"
              rel="noreferrer"
              className="btn-ghost"
            >
              <LinkedInIcon fontSize="small" /> LinkedIn
            </a>
            <a href={CV} target="_blank" rel="noreferrer" className="btn-ghost">
              <FileIcon fontSize="small" /> Download CV
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
